export const EdroloLogo = (): JSX.Element => {
  return (
    <svg
      width="459.9"
      height="89.1"
      viewBox="0 0 459.9 89.1"
      style={{ width: '100px', height: 'auto' }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Edrolo logo"
    >
      <g>
        <path
          fill="#fcfcfc"
          d="M87.7,0v21.9C75.6,21.9,65.8,12.1,65.8,0h21.9Z"
        />
        <path
          fill="#fcfcfc"
          d="M57.7,32.2h30v21.9h-32.2c-6,0-11.5-2.5-15.5-6.4-4-3.9-6.4-9.4-6.4-15.5V0h21.9v30c0,1.2,1,2.2,2.2,2.2Z"
        />
        <path
          fill="#fcfcfc"
          d="M24.1,65.8h63.6v21.9H21.9c-6.1,0-11.6-2.5-15.5-6.4-4-4-6.4-9.5-6.4-15.5V0h21.9v63.6c0,1.2,1,2.2,2.2,2.2Z"
        />
      </g>
      <g>
        <path
          fill="#fcfcfc"
          d="M122.7,87.7V0h62.8v15.5h-44.8v20.4h41.4v15.1h-41.4v21.2h44.8v15.5h-62.8,0Z"
        />
        <path
          fill="#fcfcfc"
          d="M217.2,89c-5.4,0-10.1-1.4-14.1-4.1s-7.2-6.5-9.4-11.4c-2.2-4.9-3.3-10.5-3.3-17s1.1-12,3.4-16.8c2.3-4.9,5.4-8.7,9.4-11.4,4-2.7,8.7-4.1,14-4.1s5.2.4,7.4,1.1c2.3.7,4.3,1.8,6.1,3.3s3.4,3.3,4.6,5.5h.1V0h17.4v87.7h-17.1v-9.5h-.1c-1.1,2.4-2.6,4.4-4.5,6s-3.9,2.8-6.3,3.7-4.9,1.2-7.6,1.2h0ZM221.8,74.9c2.9,0,5.4-.8,7.6-2.3,2.2-1.5,3.9-3.6,5.1-6.4s1.8-6,1.8-9.7-.6-7-1.8-9.7c-1.2-2.7-2.9-4.8-5.1-6.4-2.2-1.5-4.8-2.3-7.7-2.3s-5.2.7-7.3,2.2-3.7,3.5-4.9,6.2c-1.1,2.7-1.7,6-1.7,9.9s.6,7.2,1.7,9.9c1.2,2.7,2.8,4.8,4.9,6.2s4.5,2.2,7.3,2.2Z"
        />
        <path
          fill="#fcfcfc"
          d="M262.8,87.7V25.5h16.6v10.6h.2c1.2-3.8,3-6.5,5.4-8.3,2.4-1.8,5.7-2.7,9.8-2.7s2,0,2.8,0c.9,0,1.6,0,2.3,0v14.8c-.6,0-1.7,0-3.1-.2s-2.9-.1-4.4-.1c-2.4,0-4.5.5-6.4,1.6-1.9,1.1-3.4,2.7-4.4,4.8s-1.6,4.8-1.6,7.9v33.7h-17.3Z"
        />
        <path
          fill="#fcfcfc"
          d="M333.6,89.1c-6.2,0-11.7-1.3-16.5-4.1s-8.4-6.5-11.1-11.4c-2.6-4.9-4-10.5-4-17s1.3-12.2,4-17.1c2.6-4.9,6.4-8.7,11.1-11.4,4.8-2.7,10.2-4.1,16.5-4.1s11.8,1.4,16.6,4.1,8.4,6.5,11.1,11.4c2.6,4.9,4,10.5,4,17.1s-1.3,12.1-4,17-6.3,8.7-11.1,11.4c-4.7,2.7-10.2,4.1-16.6,4.1ZM333.6,75c2.8,0,5.3-.7,7.4-2.2,2.1-1.4,3.8-3.6,4.9-6.3,1.2-2.8,1.8-6,1.8-9.9s-.6-7.2-1.8-10-2.8-4.9-4.9-6.3c-2.1-1.5-4.6-2.2-7.4-2.2s-5.2.7-7.3,2.2c-2.1,1.5-3.8,3.6-5,6.3-1.2,2.8-1.8,6.1-1.8,10s.6,7.1,1.8,9.9,2.8,4.9,4.9,6.3c2.1,1.4,4.6,2.2,7.4,2.2Z"
        />
        <path fill="#fcfcfc" d="M389.6,0v87.7h-17.3V0h17.3Z" />
        <path
          fill="#fcfcfc"
          d="M428.3,89.1c-6.2,0-11.7-1.3-16.5-4.1s-8.4-6.5-11.1-11.4c-2.6-4.9-4-10.5-4-17s1.3-12.2,4-17.1c2.6-4.9,6.4-8.7,11.1-11.4,4.8-2.7,10.2-4.1,16.5-4.1s11.8,1.4,16.6,4.1,8.4,6.5,11.1,11.4c2.6,4.9,4,10.5,4,17.1s-1.3,12.1-4,17-6.3,8.7-11.1,11.4c-4.7,2.7-10.2,4.1-16.6,4.1ZM428.3,75c2.8,0,5.3-.7,7.4-2.2,2.1-1.4,3.8-3.6,4.9-6.3,1.2-2.8,1.8-6,1.8-9.9s-.6-7.2-1.8-10-2.8-4.9-4.9-6.3c-2.1-1.5-4.6-2.2-7.4-2.2s-5.2.7-7.3,2.2c-2.1,1.5-3.8,3.6-5,6.3-1.2,2.8-1.8,6.1-1.8,10s.6,7.1,1.8,9.9,2.8,4.9,4.9,6.3c2.1,1.4,4.6,2.2,7.4,2.2Z"
        />
      </g>
    </svg>
  );
};
